export const ElementScrollType = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0,
};

export const FilterLimit = 20;
